








import Vue from 'vue';
import {Component} from "vue-property-decorator";
import {Permissions} from "@/helpers/constants";
import HomeCustomer from "@/components/home/HomeCustomer.vue";
import HomeDriver from "@/components/home/HomeDriver.vue";
import HomeOffice from "@/components/home/HomeOffice.vue";

@Component({
	components: {HomeOffice, HomeDriver, HomeCustomer}
})
export default class Dashboard extends Vue {

	private get isCustomer(): boolean {
		return this.hasPermission(Permissions.rightCustomer);
	}

	private get isDriver(): boolean {
		return this.hasPermission(Permissions.rightDriver);
	}

	private get isOffice(): boolean {
		return this.hasPermission(Permissions.rightOffice);
	}

	private hasPermission(permission: string): boolean {
		return this.$store.getters['user/hasPermission'](permission);
	}

}
